<!--安全检查总结-->
<template>
  <div style="width: 100%; height: 100%; position: absolute">
    <h1
      style="width: 100%; height: 70px; position: absolute; color: white; font-weight: bold; font-size: 42px; line-height: 70px; padding-left: 20px; text-align: left">
      Checklist (Equipment)
      <div class="select"
           style="position: absolute; right: 5%; z-index: 9;width: 13%;display: inline-block">
        <el-select v-model="default_tag"
                   placeholder="请选择" popper-class="optionsContent"
                   @change="switch_tag">
          <el-option
            v-for="item in multi_tags"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </div>
    </h1>
    <div v-if="dataNotNull" key="1" class="checklistDiv"
         style="width: 100%; height: 793px; position: absolute; bottom: 0">
      <div class="container1" style="height: 100%;" @click=""></div>
    </div>
    <div v-else key="2"
         style="width: 100%; height: 793px; position: absolute; bottom: 0; line-height: 793px; color: #6CF; font-size: 64px;">
      No Data !
    </div>
    <div class="check_list_detail" v-show="showflag" id="check_list_detail">
      {{ select_type }}
      <div class="close_img" @click="detailClose"></div>
      <div
        style="margin-top:40px;margin-left: 12%; width:100%; height:580px;display: flex; flex-direction: column;overflow: scroll">
        <div style="width: 90%; height: 60px; display: flex">
          <div class="check_item_title">Equipment</div>
          <div class="check_item_title">Work Location</div>
        </div>
        <div style="width: 90%; height: 60px; display: flex" v-for="(item, index) in detail1_data"
             :key="'checklist1_' + index">
          <div class="check_item_title" style="font-size: 26px" @click="showDetail1(item.equipment)">{{
              item.equipment
            }}
          </div>
          <div class="check_item_title" style="font-size: 26px" @click="showDetail2(item.equipment)">view</div>
        </div>
      </div>
    </div>
    <div class="check_list_detail1" v-show="showflag1" id="check_list_detail1">
      Verification History
      <div class="close_img" @click="detail1Close"></div>
      <div style="width: 100%; height: 50px; margin-top: 10px; line-height: 50px">{{ select_device }}</div>
      <div
        style="margin-top:10px;;margin-left: 7%;  width:100%; height:480px;display: flex; flex-direction: column;overflow: scroll">
        <div style="width: 90%; height: 60px; display: flex">
          <div class="check_item_title1">Date</div>
          <div class="check_item_title2">Submitted By</div>
          <div class="check_item_title2">Verified By</div>
        </div>
        <div style="width: 90%; height: 60px; display: flex" v-for="(item, index) in detail2_data"
             :key="'checklist2_' + index">
          <div class="check_item_title1" style="font-size: 26px">{{ item.date }}</div>
          <div class="check_item_title2" style="font-size: 26px">{{ item.submit }}</div>
          <div class="check_item_title2" style="font-size: 26px">{{ item.verify }}</div>
        </div>
      </div>
    </div>
    <div class="check_list_detail1" v-show="showflag2" id="check_list_detail2">
      Work Location
      <div class="close_img" @click="detail2Close"></div>
      <div style="width: 100%; height: 50px; margin-top: 10px;line-height: 50px">{{ select_device }}</div>
      <div
        style="margin-top:10px;;margin-left: 7%;  width:100%; height:480px;display: flex; flex-direction: column;overflow: scroll">
        <div style="width: 90%; height: 60px; display: flex">
          <div class="check_item_title1" style="width: 45%">Date</div>
          <div class="check_item_title2" style="width: 50%">Location</div>
        </div>
        <div style="width: 90%; height: 60px; display: flex" v-for="(item, index) in detail2_data"
             :key="'checklist2_' + index">
          <div class="check_item_title1" style="font-size: 26px;width: 45%">{{ item.date }}</div>
          <div class="check_item_title2" style="font-size: 26px;width: 50%">{{ item.location }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import echarts from 'echarts'
import axios from 'axios'

export default {
  props: ['project_id'],
  name: "checklist",
  data() {
    return {
      my_project_id: this.project_id,
      color: this.$store.state.color.chart_color,
      myChart: null,
      name: "checklist",
      dataNotNull: true,
      default_tag: "Daily",
      multi_tags: [
        {label: "Monthly", value: "1"},
        {label: "Daily", value: "0"},
        {label: "Acc.", value: "2"},
      ],
      checkes: [],
      legends: [],
      select_type: '',
      select_device: '',
      showflag: false,
      showflag1: false,
      showflag2: false,
      detail_data: [
        {
          label: 'Pending 0 0%',
          children: []
        }, {
          label: 'Completed 0 0%',
          children: []
        },
        {
          label: 'Time Out 0 0%',
          children: []
        }
      ],
      defaultProps: {
        children: 'children',
        label:
          'label'
      },
      detail1_data: [],
      detail2_data: [],
    }
  }
  ,
  methods: {
    handleNodeClick(params) {
    },
    dragFunc(id) {
      var Drag = document.getElementById(id);
      Drag.onmousedown = function (event) {
        var ev = event || window.event;
        event.stopPropagation();
        var disX = ev.clientX - Drag.offsetLeft;
        var disY = ev.clientY - Drag.offsetTop;
        document.onmousemove = function (event) {
          var ev = event || window.event;
          Drag.style.left = ev.clientX - disX + "px";
          Drag.style.top = ev.clientY - disY + "px";
          Drag.style.cursor = "move";
        };
      };
      Drag.onmouseup = function () {
        document.onmousemove = null;
        this.style.cursor = "default";
      }
    },
    showDetail1(equipment) {
      var that = this
      that.showflag1 = true
      that.select_device = equipment
      let index = that.legends.indexOf(that.select_type.substring(0, 19) + '\n' + that.select_type.substring(19, that.select_type.length))
      for (var k in that.checkes[index].device_list) {
        if (equipment == that.checkes[index].device_list[k].equipment) {
          that.detail2_data = that.checkes[index].device_list[k].check_list
          break
        }
      }
    },
    showDetail2(equipment) {
      var that = this
      that.showflag2 = true
      that.select_device = equipment
      let index = that.legends.indexOf(that.select_type.substring(0, 19) + '\n' + that.select_type.substring(19, that.select_type.length))
      for (var k in that.checkes[index].device_list) {
        if (equipment == that.checkes[index].device_list[k].equipment) {
          that.detail2_data = that.checkes[index].device_list[k].check_list
          break
        }
      }
    },
    detailClose() {
      this.showflag = false
      this.showflag1 = false
      this.detail1_data = []
    },
    detail1Close() {
      this.showflag1 = false
    },
    detail2Close() {
      this.showflag2 = false
    },
    switch_tag(label) {
      this.sum = 0
      this.getData(label)
    },
    init() {
      this.myChart.resize()
      window.addEventListener("resize", function () {
        this.myChart.resize()
      }.bind(this))
    },
    analysisResult(result) {
      var checkes = []
      var types = []
      var type_device_list = []

      for (var i in result) {
        var device_id = result[i].device_id
        var device_name = result[i].device_name
        var apply_time = result[i].apply_time
        var user_name = result[i].submit
        var verify = result[i].verify
        var location = result[i].block
        var type_name = result[i].type_name_en
        if (type_name.indexOf('For') > 0) {
          type_name = type_name.split('For')[1]
        }
        type_name = type_name.substring(0, 19) + '\n' + type_name.substring(19, type_name.length)
        // var type_name=result[i].type_name_en.substring(0, 31) + '\n' + result[i].type_name_en.substring(31, result[i].type_name_en.length)
        var k = 0
        for (k in checkes) {
          if (checkes[k].name == type_name) {
            checkes[k].value += 1
            break
          }
          k = parseInt(k) + 1
        }
        if (k == checkes.length) {
          let last_index = checkes.length - 1
          if (last_index >= 0) {
            checkes[last_index].device_list = type_device_list
            // checkes[last_index].value=type_device_list.length
            type_device_list = []
          }
          types.push(type_name)
          checkes.push({name: type_name, value: 1, device_list: []})
        }
        var v = 0
        for (v in type_device_list) {
          if (type_device_list[v].equipment == device_name) {
            type_device_list[v].check_list.push({
              date: apply_time,
              submit: user_name,
              verify: verify,
              location: location
            })
            break
          }
          v = parseInt(v) + 1
        }
        if (v == type_device_list.length) {
          type_device_list.push({
            device_id: device_id,
            equipment: device_name,
            check_list: [
              {
                date: apply_time,
                submit: user_name,
                verify: verify,
                location: location
              }
            ]
          })
        }
      }
      let last_index = checkes.length - 1
      if (last_index >= 0) {
        checkes[last_index].device_list = type_device_list
        // checkes[last_index].value=type_device_list.length
      }
      this.checkes = checkes
      this.legends = types
      return {checkes: checkes, legends: types}
    },
    //获取当前日期，格式YYYY-MM-DD
    getNowFormatDate() {
      var date = new Date();
      var seperator1 = "-";
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      var currentdate = year + seperator1 + month + seperator1 + strDate;
      return currentdate;
    },
    getData(period) {
      var that = this
      let postData = {
        project_id: this.my_project_id,
        // start_date: this.getNowFormatDate(),
        // end_date: this.getNowFormatDate(),
        period: period,
        user: window.localStorage.getItem("token_key"),
        // token: window.localStorage.getItem('token')
        token: "lalala"
      }
      axios.post(this.$store.getters.getCmsServer + "DBProjChecklist", postData).then(resp => {
        var errNo = resp.data.errno
        var errStr = resp.data.errstr_cn
        this.myChart.hideLoading()
        if (errNo == "0") {
          this.dataNotNull = true
          that.$nextTick().then(() => {
            that.init_chart()
            var result = resp.data.result;
            var data = this.analysisResult(result)
            this.myChart.setOption({
              yAxis: {
                data: data.legends
              },
              series: [
                {
                  data: data.checkes
                }
              ]
            })
          })

        } else {
          this.dataNotNull = false
        }
      }).catch(error => {
        alert(error)
        this.myChart.hideLoading()
        this.dataNotNull = false
      })
    },
    init_chart() {
      let that = this
      this.myChart = echarts.init(document.querySelector('.checklistDiv .container1'))
      this.myChart.setOption({
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'none'
          },
          formatter: function (params) {
            return params[0].name.replace(/\n/, "") + ': ' + params[0].value
          },
          textStyle: {
            fontSize: '40'
          }
        },
        dataZoom: [
          {
            show: true,
            realtime: true,
            yAxisIndex: [0],
            left: '95%',
            startValue: 0, // 从头开始。
            endValue: 4,  // 一次性展示5个。
            showDetail: false,
            zoomLock: true,
            width: '3%',
          }
        ],
        grid: {
          left: 330
        },
        xAxis: {
          type: 'value',
          show: false,
          axisLabel: {
            formatter: '{value}'
          }
        },
        yAxis: {
          type: 'category',
          inverse: true,
          data: [],
          axisLine: {
            show: true,
            lineStyle: {
              color: '#6CF'
            }
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            margin: 15,
            show: true,
            textStyle: {
              color: '#FFF',
              fontSize: 26
            }
          },
          splitLine: {
            show: false
          }
        },
        series: [
          {
            name: 'Checklist',
            type: 'bar',
            barWidth: '60%',
            data: [],
            label: {
              normal: {
                show: true,
                color: '#6cf',
                position: 'right',
                formatter: '{c}',
                textStyle: {
                  fontSize: 42
                }
              }
            },
            itemStyle: {
              normal: {
                color: function (params) {
                  return that.color[params.dataIndex]
                },
              }
            },
          }
        ]
      })
      this.myChart.on('click', function (param) {
        that.$nextTick(() => {
          let index = param.dataIndex
          that.select_type = param.data.name.replace(/[\r\n]/g, "")
          that.showflag = true
          that.detail1_data = that.checkes[index].device_list
        })
      })
    }
  },
  beforeDestroy() {
    if (this.myChart) {
      this.myChart.clear()
    }
  },
  mounted() {
    var name = window.localStorage.getItem('token_key')
    if ("videmo" == name) {
      this.my_project_id = "3177"
    }
    this.init_chart()
    this.getData('0')
    // this.init()
    this.dragFunc("check_list_detail")
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
.check_list_detail {
  background-color: rgb(248, 248, 248);
  border-width: 2px;
  border-color: #2db7f5;
  border-radius: 10px;
  position: absolute;
  width: 90%;
  height: 80%;
  left: 5%;
  top: 12%;
  text-align: center;
  font-size: 40px;
  z-index: 1000;
}

.check_list_detail1 {
  background-color: rgb(248, 248, 248);
  border-width: 2px;
  border-color: #2db7f5;
  border-radius: 10px;
  position: absolute;
  width: 80%;
  height: 70%;
  left: 10%;
  top: 16%;
  text-align: center;
  font-size: 40px;
  z-index: 1000;
  box-shadow: inset 0px 0px 5px 1px #66CCFF;
}

.close_img {
  position: absolute;
  background-image: url("../../assets/close.png");
  background-repeat: no-repeat;
  right: 10px;
  top: 10px;
  width: 20px;
  height: 20px;
}

.check_item_title {
  width 50%
  height 60px
  line-height 60px
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  text-align center
  -webkit-box-orient: vertical;
}

.check_item_title1 {
  width 30%
  height 60px
  line-height 60px
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  text-align center
  -webkit-box-orient: vertical;
}

.check_item_title2 {
  width 35%
  height 60px
  line-height 60px
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  text-align center
  -webkit-box-orient: vertical;
}

.el-tree-node__label {
  font-size: 30px;
}

.el-tree-node__expand-icon {
  font-size: 30px;
}

.el-tree-node__content {
  height: 60px;
}
</style>



// WEBPACK FOOTER //
// src/components/safety_manage/checklist.vue